module.exports = __webpack_public_path__ + "img/pub_play@2x.35e2ba00.png";